/** Shape sent to PUT/POST /events (strips react-admin metadata). */
export function normalizeEventPayload(data: Record<string, unknown>) {
  const venues = Array.isArray(data.venues)
    ? data.venues
        .map((row) => {
          const venue = row as Record<string, unknown>;
          return {
            code: String(venue.code ?? "").trim(),
            label: String(venue.label ?? "").trim(),
            role: venue.role,
            sortOrder:
              venue.sortOrder != null && venue.sortOrder !== ""
                ? Number(venue.sortOrder)
                : undefined,
          };
        })
        .filter((v) => v.code && v.label && v.role)
    : undefined;

  const sequences = Array.isArray(data.sequences)
    ? data.sequences
        .map((row) => {
          const seq = row as Record<string, unknown>;
          const type = seq.type;
          if (type !== "NIYAAZ_FORM" && type !== "NIYAAZ_RECEIPT") {
            return null;
          }
          const prefix = typeof seq.prefix === "string" ? seq.prefix.trim() : "";
          if (!prefix) {
            return null;
          }
          return {
            type,
            venueCode:
              type === "NIYAAZ_FORM" ? String(seq.venueCode ?? "").trim() || undefined : "",
            prefix,
            currentValue:
              seq.currentValue != null && seq.currentValue !== "" ? Number(seq.currentValue) : 0,
          };
        })
        .filter(Boolean)
    : undefined;

  const payload: Record<string, unknown> = {
    name: data.name,
    fromDate: data.fromDate,
    toDate: data.toDate,
    hijriYear: data.hijriYear,
    slug: data.slug,
    type: data.type,
    zabihatAmount: data.zabihatAmount,
    chairAmount: data.chairAmount,
    mehmaanAmount: data.mehmaanAmount,
    relayAmount: data.relayAmount,
    pirsaAmount: data.pirsaAmount,
    relayEventId:
      data.type === "ASHARA" && data.relayEventId != null && String(data.relayEventId).trim()
        ? data.relayEventId
        : null,
  };

  if (venues && venues.length > 0) {
    payload.venues = venues;
  }

  if (sequences && sequences.length > 0) {
    payload.sequences = sequences;
  }

  return payload;
}
